/**
 * @file Time Filters / ES module
 * @module filters/time-filter
 * @author Surmon <https://github.com/surmon-china>
 */

// 取剩余秒
const pluralize = (time, label) => {
  return time + label + '前'
}

// 转换为本地时间格式
export const toLocalString = date => {
  return date ? new Date(date).toLocaleString() : date
}

// 相对时间过滤器，传入时间，返回距离今天有多久
export const timeAgo = (time) => {
  time = time instanceof Date ? time : new Date(time)
  const between = Date.now() / 1000 - (Number(time) / 1000)
  if (between < 3600) {
    return Object.is(~~(between / 60), 0)
      ? isEnLang ? 'just now' : '刚刚'
      : pluralize(~~(between / 60),  ' 分钟')
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' 小时')
  } else {
    return pluralize(~~(between / 86400), ' 天')
  }
}

// YMDHMS 时间转换过滤器
export const toYMD = (date, language) => {
  if (!date) return date
  date = new Date(date)
  const am = (language && language === systemConstants.Language.En) ? 'am' : '上午'
  const pm = (language && language === systemConstants.Language.En) ? 'pm' : '下午'
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours() > 11 ? pm : am
  return `${year}/${month}/${day} ${hour}`
}

export const dateFtt = ( date, val) =>  { 
  if(!date) {
    return " "
  }
  date = new Date(date)
  val = val ? val : "yyyy-MM-dd hh:mm:ss"
  let o = {   
    "M+" : date.getMonth()+1,                  
    "d+" : date.getDate(),                    
    "h+" : date.getHours(),                   
    "m+" : date.getMinutes(),                
    "s+" : date.getSeconds(),                 
    "q+" : Math.floor((date.getMonth()+3)/3), 
  };   
  if(/(y+)/.test(val))
  val=val.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));   
  for(let k in o)   
    if(new RegExp("("+ k +")").test(val))   
    val = val.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));   
  return val;   
} 
